import Cookie from 'js-cookie';
import store from 'store';
import env from './env';

const SET_DEBUG_MODE = () => setCookie('apa-debug', true); // eslint-disable-line

const DEBUG_MODE = () => location.href.indexOf('apa-debug') !== -1 || getCookie('apa-debug') === 'true'; // eslint-disable-line

const DEBUG_METRICS = () => location.href.indexOf('apa-metrics') !== -1 || getCookie('apa-metrics') === 'true'; // eslint-disable-line

const LOG = (...args) => {
  if (isBrowser() && DEBUG_MODE()) { // eslint-disable-line
    const newArgs = Array.prototype.slice.call(args);
    newArgs.unshift('%c APA-SITE ', 'background: #4a4a4a; color: #FFF; font-weight: 600; text-transform: uppercase;', '[DEBUG: ON]');
    console.log(...newArgs);
  }
};

const transformObjectIntoParam = object => Object.keys(object).map(i => `${i}=${object[i]}`).join('&');

const contains = (_array, value) => _array.indexOf(value) > -1;

const isBrowser = new Function('try {return this===window;}catch(e){ return false;}'); // eslint-disable-line

const getCookie = cname => Cookie.get(cname);

const setCookie = (name, value, attr = {}) => {
  const inFifteenMinutes = new Date(new Date().getTime() + (15 * 60 * 1000));
  const attributes = {
    domain: '.clicrbs.com.br',
    expires: attr.expires || inFifteenMinutes,
    ...attr
  };
  Cookie.set(name, value, attributes);
};

const removeCookie = (cname) => {
  Cookie.remove(cname, { domain: '.clicrbs.com.br' });
};

const removeSessionCookie = (offerId) => {
  // Delete cart cookie session to prevent it to be used for another customer
  removeCookie(`apa-${offerId}`);
  removeCookie('apa-ex-subscriber');
  removeCookie('apa-ex-subscriber-origin-offer');
  removeCookie('apa-unfinished-cart');

  // Delete metrics cookie session
  removeCookie(`apa-${offerId}-params`);
};

const reloadIfError = (props) => {
  props.setLoader(true);

  const offerId = props.offerId || parseInt(window.location.href.replace(/(http(s)?:\/\/)/g, '').split('/')[2], 10);
  const { pathname } = window.location;
  removeCookie(`apa-${offerId}`);

  /* istanbul ignore next */
  setTimeout(() => {
    window.location.href = pathname ? `${pathname}${props.params}` : `/oferta/${offerId}${props.params}`;
    return true;
  }, 500);
};

/* istanbul ignore next */
const KM_API = {
  km_record: (properties) => {
    const _kmq = '_kmq' in window ? window._kmq : [];
    LOG('[KM_API]', properties);
    return _kmq.push(['record', properties.km_event, properties.km_property]);
  },
  km_identify: (properties) => {
    const _kmq = '_kmq' in window ? window._kmq : [];
    LOG('[KM_API]', properties);
    return _kmq.push(['identify', properties.km_property.email]);
  },
  km_reset: (properties) => {
    const _kmq = '_kmq' in window ? window._kmq : [];
    LOG('[KM_API]', properties);
    return _kmq.push(['clearIdentity']);
  },
};

/* istanbul ignore next */
const ZM_API = {
  km_record: (properties) => {
    const _zmq = '_zmq' in window ? window._zmq : [];
    LOG('[ZM_API]', properties);
    return _zmq.push(['record', properties.km_event, properties.km_property]);
  },
  km_identify: (properties) => {
    const _zmq = '_zmq' in window ? window._zmq : [];
    LOG('[ZM_API]', properties);
    return _zmq.push(['identify', properties.km_property.email]);
  },
  km_reset: (properties) => {
    const _zmq = '_zmq' in window ? window._zmq : [];
    LOG('[ZM_API]', properties);
    return _zmq.push(['clearIdentity']);
  },
};

const apaAnalytics = (properties) => {
  const dl = window.dataLayer || [];
  const dlNew = window.dataLayerNew || []; // Temporary dataLayer
  /* istanbul ignore next */
  if (properties.event in KM_API) {
    KM_API[properties.event](properties);
  }
  /* istanbul ignore next */
  if (properties.event in ZM_API) {
    ZM_API[properties.event](properties);
  }
  dl.push(properties);
  dlNew.push(properties); // Temporary dataLayer
  LOG('[apaAnalytics]', properties);
  return dl;
};

const removeFalsy = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((prop) => {
    if (obj[prop]) { newObj[prop] = obj[prop]; }
  });
  return newObj;
};


const parseMediaType = (mediaTypeValue) => {
  if (mediaTypeValue) {
    return `${mediaTypeValue.replace(/(gtm-assine-|-piano)/g, '')}${
      mediaTypeValue.match(/header|footer/) ? '' : '-piano'
    }`;
  }

  return 'landing-page';
};

const subscriptionPlans = (subscriptions) => {
  if (!subscriptions || subscriptions.length <= 0) return 'não possui';

  return subscriptions
    .map((subscription) =>
      `${subscription.product} - ${subscription.subscriptionType}`).join(' | ');
};

const getUserFromCookie = () => {
  const cookieNossaSession = getCookie('nossaSession');
  const cookieUserInfo = getCookie('nossaUserInfo');
  const hasUserCookie = cookieNossaSession && cookieUserInfo && cookieUserInfo !== '';
  return hasUserCookie && cookieUserInfo ? JSON.parse(decodeURIComponent(cookieUserInfo)) : {};
};

const limitStringSize = (value) => (value ? value.substring(0, 100) : '');

const mountUserData = () => {
  const user = {
    user_id: '',
    user_overdue: '',
    user_identified: 'não-identificado',
    user_status: '',
    user_person_type: '',
    user_team: '',
    user_rival_news: '',
    user_subscription_plan: 'não possui',
    user_signature: ''
  };

  const { userInfo } = getUserFromCookie();
  if (userInfo) {
    const {
      uid,
      nonOverdue,
      status,
      personType,
      heartTeamEnum,
      rivalNews,
      subscriptions,
      subscriber,
      employee,
      email,
      firstName,
      lastName,
      phones
    } = userInfo;

    const phone = phones[0] || {};
    const { areaCode, phoneNumber } = phone;

    const userCompleteName = (firstName && lastName) ? `${firstName} ${lastName}` : '';
    const userCompletePhone = (areaCode && phoneNumber) ? `(${areaCode}) ${phoneNumber}` : '';

    const userSignature = employee ? 'funcionario' : (subscriber ? 'assinante' : 'nao-assinante');
    user.user_id = uid;
    user.user_name = userCompleteName;
    user.user_phone = userCompletePhone;
    user.user_email = email;
    user.user_overdue = !nonOverdue;
    user.user_identified = 'identificado';
    user.user_status = status;
    user.user_person_type = personType;
    user.user_team = heartTeamEnum;
    user.user_rival_news = rivalNews;
    user.user_subscription_plan = subscriptionPlans(subscriptions);
    user.user_signature = userSignature;
  }

  return user;
};

const filterMetricsEasyCheckout = (data = {}, filter = true) => {
  const info = {
    nome: data.nome || '',
    dispositivo: data.dispositivo || '',
    plataforma: data.plataforma || '',
    origem: data.origem || '',
    campanha: data.campaign || '',
    content: data.content || '',
    produto: data.produto || '',
    editoria: data.editoria || '',
    subeditoria: data.subeditoria || '',
    'url materia': data.url || '',
    'id materia': data.idMateria || '',
    'id oferta': data.offerId || '',
    'id oferta entrada': data.oldOfferId || '',
    'id da compra': data.saleOrderId || '',
    modalidade: data.modality || '',
    'tipo usuario': data.digitalId || '',
    'tipo login': data.loginType || '',
    'metodo login': data.methodLogin || '',
    'metodo login id': data.methodLoginId || '',
    'com clube': data.clube || '',
    'preco' : data.price || '', //eslint-disable-line
    'status da compra': data.status || '',
    uuid: data.uuid || '',
  };

  LOG('[FILTER_METRICS]', info);

  return filter ? removeFalsy(info) : info;
};

const getEventSuffix = title => `${title} - Easy Checkout`;

// window.location.pathname
const metricsPageTitle = (path) => {
  let pageTitle = 'bah... pagina nao encontrada';

  const map = [
    { pathRegex: '.*/identifique-se.*', title: 'Identificação' },
    { pathRegex: '.*/cadastro.*', title: 'Criar Nova Conta' },
    { pathRegex: '.*/assinante.*', title: 'Já é Assinante' },
    { pathRegex: '.*/revisao.*', title: 'Revisão Pedido' },
    { pathRegex: '.*/cadastro/confirmar-dados.*', title: 'Confirmar dados' },
    { pathRegex: '.*/pagamento', title: 'Formulário Pagamento' },
    { pathRegex: '.*/pagamento/sucesso.*', title: 'Sucesso' },
    { pathRegex: '.*/pagamento/sucesso-pendente.*', title: 'Sucesso' },
    { pathRegex: '.*/pagamento/erro.*', title: 'Falha na Compra' },
    { pathRegex: '.*/pagamento/erro-quarentena.*', title: 'Falha na compra quarentena' },
    { pathRegex: '.*/pagamento/erro-retentativa.*', title: 'Falha na compra - Retentativa' },
    { pathRegex: '.*/pagamento/erro-limite.*', title: 'Falha na compra - Limite atingido' },
  ];

  map.forEach((page) => {
    if (path.match(new RegExp(page.pathRegex, 'g'))) {
      LOG('[PAGE REGEX ENTROU]', page.title);
      pageTitle = page.title;
    }
  });

  return getTitle(pageTitle); //eslint-disable-line
};

const getTitle = (title) => {
  let returnFunction;
  if (title) {
    returnFunction = getEventSuffix(title);
  } else {
    returnFunction = metricsPageTitle(window.location.pathname);
  }
  return returnFunction;
};

const getUrl = (location, modality, suffix = '') => [location.pathname, suffix].join('').replace('oferta', modality || 'oferta');

const getUserData = user => ({
  nome: user.name || '',
  email: user.email || '',
  digitalId: user.digitalId || '',
  loginType: user.loginType || ''
});

const stringToSlug = (str) => {
  let copyStr = str;
  copyStr = copyStr.replace(/^\s+|\s+$/g, ''); // trim
  copyStr = copyStr.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'ãàáäâèéëêìíïîõòóöôùúüûñç·/_,:;';
  const to = 'aaaaaeeeeiiiiooooouuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    copyStr = copyStr.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  copyStr = copyStr.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return copyStr;
};

const parseTitle = str => {
  let copyStr = str;
  copyStr = copyStr.replace(/^\s+|\s+$/g, ''); // trim

  // remove accents, swap ñ for n, etc
  const from = 'ãàáäâèéëêìíïîõòóöôùúüûñç·/_,:;';
  const to = 'aaaaaeeeeiiiiooooouuuunc------';
  // eslint-disable-next-line no-plusplus
  for (let i = 0, l = from.length; i < l; i++) {
    copyStr = copyStr.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  copyStr = copyStr.toLowerCase().replace(/[^a-z0-9 -]/g, '');

  return copyStr;
};

const getOSUser = (userAgent) => {
  const source = userAgent || window.navigator.userAgent;
  if (source.match(/Windows/g)) {
    return 'windows';
  }
  if (source.match(/iPhone/g)) {
    return 'ios';
  }
  if (source.match(/Mac/g)) {
    return 'macos';
  }
  if (source.match(/Android/g)) {
    return 'android';
  }
  if (source.match(/Linux/g)) {
    return 'linux';
  }
  return '';
};

const getUserAgent = (userAgent) => {
  const source = userAgent || window.navigator.userAgent;
  if (source.match(/Firefox/g)) {
    return 'firefox';
  }
  if (source.match(/Chrome/g)) {
    return 'chrome';
  }
  if (source.match(/Safari/g)) {
    return 'safari';
  }
  if (source.match(/Opera/g)) {
    return 'opera';
  }
  if (source.match(/Explorer|Edge/g)) {
    return 'iexplorer';
  }
  return '';
};

/* istanbul ignore next */
const RavenIdentify = (data = {}) => { // eslint-disable-line
  // Raven.setUserContext(data); // eslint-disable-line
};

const isValidEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return re.test(String(email).toLowerCase());
};

const isInsideApp = (offerId = 0) => {
  const params = getCookie(`apa-${offerId}-params`);
  const isRunningApp = /utm_source=(.*_app)/gi.test(params) && /utm_medium=App/gi.test(params);

  return isRunningApp;
};

const isFacebookNavigator = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if ((userAgent.indexOf('FBAN') > -1) || (userAgent.indexOf('FBAV') > -1)) {
    return true;
  }
  return false;
};

const setLocalStorage = (key, val, exp = 86400000) => {
  store.set(key, {
    val,
    exp,
    time: new Date().getTime(),
  });
};

const getLocalStorage = key => {
  const info = store.get(key);

  if (!info) {
    return null;
  }
  if (new Date().getTime() - info.time > info.exp) {
    return null;
  }

  return info.val;
};

const triggerEvent = (el, eventName, options) => {
  let event;

  if (typeof window.CustomEvent === 'function') {
    event = new CustomEvent(eventName, options); // eslint-disable-line
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, options);
  }

  el.dispatchEvent(event);
};

const setupZM = () => {
  const dependencies = [
    env() !== 'production' ? '//ad.clicrbs.com.br/beta/zm/zem-metrics.min.js' : '//ad.clicrbs.com.br/zm/zem-metrics.min.js'
  ];

  const loadedQueue = [];

  const _zms = (url) => {
    const d = document;
    const f = d.getElementsByTagName('script')[0];
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    f.parentNode.insertBefore(s, f);
    s.onload = () => {
      loadedQueue.push(url);
      if (loadedQueue.length === dependencies.length) {
        triggerEvent(document, 'zemetrics-loaded');
        const ZemMetrics = 'ZemMetrics' in window ? window.ZemMetrics : []; // eslint-disable-line
        window._zmq = window.ZemMetrics || [];
      }
    };
  };
  LOG('[Metrics][ZM_API] loading ZemMetrics');
  dependencies.forEach(value => _zms(value));
};

const setupSmartOcto = () => {
  const script = document.createElement('script');
  script.id = 'smart-octo';
  script.type = 'text/javascript';
  script.innerHTML = `
    _ain = {
      id: "2891${env() !== 'production' ? 0 : ''}",
      trackauto: false
    };

    // The following code (let's call it stf.js) actually loads the tracker from CDN:
    (function (d, s) {
      var sf = d.createElement(s);
      sf.type = 'text/javascript';
      sf.async = true;
      sf.src = (('https:' == d.location.protocol)
        ? 'https://d7d3cf2e81d293050033-3dfc0615b0fd7b49143049256703bfce.ssl.cf1.rackcdn.com'
        : 'http://t.contentinsights.com') + '/stf.js';
      var t = d.getElementsByTagName(s)[0];
      t.parentNode.insertBefore(sf, t);
    })(document, 'script');
  `;

  document.body.appendChild(script);

  const scriptTentacle = document.createElement('script');
  scriptTentacle.innerHTML = `
    window.tentacles = {apiToken: '7t9p9nd499ldf9dwbtoavbxdal00b3sv'};
  `;

  document.body.appendChild(scriptTentacle);

  const scriptLink = document.createElement('script');
  scriptLink.src = 'https://tentacles.smartocto.com/ten/tentacle.js';

  document.body.appendChild(scriptLink);
  LOG('[Metrics][Octo] loading SmartOcto');
};

const getParameterByName = (name, url) => {
  let location;
  if (!url) {
    location = window.location.search;
  }

  const stringName = name.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${stringName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(location);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const parseQueryString = (queryString) => {
  const arr = queryString.replace(/\?/g, '').split('&');
  const queryParsed = {};
  arr.forEach((item) => {
    const itemSplitted = item.split('=');
    const [index, value] = itemSplitted;
    queryParsed[index] = value;
  });

  return queryParsed;
};

const stringifyObject = (obj) => {
  let queryString = '?';
  Object.keys(obj).forEach((value, key) => {
    queryString += `${key === 0 ? '' : '&'}${value}=${obj[value]}`;
  });

  return queryString;
};

const filterUrlFolder = (folder) => {
  if (!folder) return '';
  if (folder !== 'noticia' && folder.indexOf('?') === -1) return folder;
  return '';
};

const extractInfoFromURl = (url) => {
  const currUrl = typeof (url) !== 'undefined' ? url : '';
  const splittedUrl = currUrl.split('/').slice(3);
  const articleId = /-([\w\d]+)\.html/gm.exec(currUrl);
  const infoObject = {
    editoria: filterUrlFolder(splittedUrl[0]),
    subeditoria: filterUrlFolder(splittedUrl[1]),
    idMateria: articleId && articleId.length ? articleId[1] : '',
    url: currUrl
  };

  return infoObject;
};

const purchase = ({
  paymentData,
  purchaseFunc,
  cleanPaymentDataFunc,
  savePurchaseFunc,
  setLoaderFunc,
  history,
  params,
  handleErrorsFunc,
  offerId,
}) => {
  purchaseFunc(paymentData)
    .then((response) => {
      // Clean purchase data
      cleanPaymentDataFunc();
      const { saleReturn } = response.data.purchase;

      // Send purchase data to analytics
      savePurchaseFunc(response.data.purchase);

      // Log info to Graylog
      // const message = `Sending transaction to GA. Sale Order ID: ${response.data.purchase.saleOrderId}\n ${JSON.stringify(response.data.purchase.saleOrderDetail)}`;
      // this.props.logError(message, email).then(() => {
      //   LOG('[Graylog] Graylog received transaction log', message);
      // }).catch(({ graphQLErrors }) => {
      //   LOG('[Graylog] Cant send transaction log', graphQLErrors);
      // });

      LOG('[payment]', 'submit', 'response', response);

      removeSessionCookie(offerId);

      setLoaderFunc(false);

      if (saleReturn === 'PENDING') {
        history.push({
          pathname: '/pagamento/sucesso-pendente',
          search: params,
        });
      } else {
        history.push({ pathname: '/pagamento/sucesso', search: params });
      }
    })
    .catch((response) => {
      const { graphQLErrors /* networkError */ } = response;
      LOG('response with error', response);
      handleErrorsFunc(graphQLErrors, response);
      setLoaderFunc(false);
    });
};


const getGAClientId = () => {
  try {
    const match = document.cookie.match(/_ga=(GA1\.\d\.\d+.\d+)/);
    return match ? `${match[1].split('.')[2]}.${match[1].split('.')[3]}` : null;
  } catch (e) {
    return null;
  }
};

// eslint-disable-next-line max-params
const convertListToProps = (list, propName, separetor = '_', resolve = (item) => item) => {
  if (!list || list.length === 0) {
    return { [propName]: 'nao se aplica' };
  }

  const props = {};
  let count = 1;

  if (list.forEach) {
    list.forEach((item) => {
      if (count === 1) {
        props[propName] = resolve(item);
      } else {
        props[`${propName}${separetor}${count}`] = resolve(item);
      }

      count += 1;
    });
  }

  return props;
};

export {
  LOG,
  getUrl,
  getTitle,
  contains,
  isBrowser,
  getCookie,
  setCookie,
  getOSUser,
  DEBUG_MODE,
  getUserData,
  removeFalsy,
  getUserAgent,
  removeCookie,
  removeSessionCookie,
  apaAnalytics,
  stringToSlug,
  reloadIfError,
  DEBUG_METRICS,
  RavenIdentify,
  getEventSuffix,
  SET_DEBUG_MODE,
  metricsPageTitle,
  transformObjectIntoParam,
  filterMetricsEasyCheckout,
  isValidEmail,
  isInsideApp,
  isFacebookNavigator,
  setLocalStorage,
  getLocalStorage,
  triggerEvent,
  setupZM,
  setupSmartOcto,
  parseTitle,
  getParameterByName,
  parseQueryString,
  stringifyObject,
  extractInfoFromURl,
  purchase,
  parseMediaType,
  getUserFromCookie,
  limitStringSize,
  mountUserData,
  subscriptionPlans,
  getGAClientId,
  convertListToProps,
};
